import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MaterialModule } from '../../shared/material.module';
import { InformateComponent } from './components/informate/informate.component';
import { PassLabelPipe } from './core/Pipes/pass-label.pipe';
import { OverlayModule } from '@angular/cdk/overlay';

import {
    InformateHeaderComponent,
    AdvancedOutputComponent,
    DiagramsComponent,
    MatrixComponent,
    MatrixAddOrCreateComponent,
    FlangeInputComponent,
    StressFactorsOutputComponent,
    TighteningProcedureInputComponent,
    ToolsInputComponent,
    InformateSubHeaderComponent,
    ClampInputComponent,
    ClampComponent,
    CustomFlangeComponent,
    CustomFlangeInputComponent,
    EngineeredJointComponent,
    EngineeredJointInputComponent,
    ProcessInformationInputComponent,
    StandardFlangeComponent,
} from './components/index';

import {
    AdditionalComponentComponent,
    AdvanceOptionsComponent,
    BoltHoleDiameterComponent,
    BoltMaterialComponent,
    BoltQuantityComponent,
    BoltTypeComponent,
    ClampManufacturerComponent,
    ClampMaterialComponent,
    ClampSizeComponent,
    FlangeFacingTypeComponent,
    FlangeMaterialComponent,
    FlangeTypeComponent,
    FlangeType2Component,
    GasketComponent,
    GasketCompThicknessComponent,
    HubMaterialComponent,
    JointConfigurationComponent,
    JointThicknessComponent,
    MComponent,
    MinGasketStressComponent,
    MaxGasketStressComponent,
    MisalignmentFactorComponent,
    NutStandardComponent,
    PAdditionalComponent,
    PipeScheduleComponent,
    PipeSizeComponent,
    PressureClassComponent,
    RecGasketStressComponent,
    ReducedAreaBoltingComponent,
    SealRingMaterialComponent,
    SealRingComponent,
    StandardComponent,
    ThreadTypeBoltSizeComponent,
    TighteningSpecificationComponent,
    WashersComponent,
    YComponent,
} from './components/controls/index';
import { OverrideFlangeComponent } from './components/controls/override-flange/override-flange.component';
import { NearestObstructionComponent } from './components/controls/nearest-obstruction/nearest-obstruction.component';
import { ToolComponent } from './components/controls/tool/tool.component';
import { LubricantComponent } from './components/controls/lubricant/lubricant.component';
import { TighteningMethodComponent } from './components/controls/tightening-method/tightening-method.component';
import { PercentageCoverComponent } from './components/controls/percentage-cover/percentage-cover.component';
import { MatrixNameComponent } from './components/controls/matrix-name/matrix-name.component';
import { MatrixQuantityComponent } from './components/controls/matrix-quantity/matrix-quantity.component';
import { MatrixJointIdComponent } from './components/controls/matrix-joint-id/matrix-joint-id.component';
import { MatrixImportComponent } from './components/controls/matrix-import/matrix-import.component';
import { MatrixExportComponent } from './components/controls/matrix-export/matrix-export.component';
import { MatrixListComponent } from './components/controls/matrix-list/matrix-list.component';
import { MatrixCreateComponent } from './components/controls/matrix-create/matrix-create.component';
import { MatrixModifyComponent } from './components/controls/matrix-modify/matrix-modify.component';
import { MatrixRemoveComponent } from './components/controls/matrix-remove/matrix-remove.component';
import { MatrixRowModifyComponent } from './components/controls/matrix-row-modify/matrix-row-modify.component';
import { MatrixRowRemoveComponent } from './components/controls/matrix-row-remove/matrix-row-remove.component';
import { MatrixRowDuplicateComponent } from './components/controls/matrix-row-duplicate/matrix-row-duplicate.component';
import { MatrixRowViewComponent } from './components/controls/matrix-row-view/matrix-row-view.component';
import { DiagramImageComponent } from './components/controls/diagram-image/diagram-image.component';
import { DiagramFlangeOverridesComponent } from './components/controls/diagram-flange-overrides/diagram-flange-overrides.component';
import { DiagramFlangeFacingOverridesComponent } from './components/controls/diagram-flange-facing-overrides/diagram-flange-facing-overrides.component';
import { DiagramGasketOverridesComponent } from './components/controls/diagram-gasket-overrides/diagram-gasket-overrides.component';
import { BreakoutComponent } from './components/controls/breakout/breakout.component';
import { DiagramDimensionsComponent } from './components/controls/diagram-dimensions/diagram-dimensions.component';
import { WarningOutputComponent } from './components/warning-output/warning-output.component';
import { HomeModule } from '../home/home.module';
import { BoltAndPumpOutputComponent } from './components/CalculationOutput/bolt-and-pump-output/bolt-and-pump-output.component';
import { CalculationOutputComponent } from './components/CalculationOutput/calculation-output/calculation-output.component';
import { BoltOutputComponent } from './components/CalculationOutput/bolt-output/bolt-output.component';
import { PumpOutputComponent } from './components/CalculationOutput/pump-output/pump-output.component';
import { StandardOutputComponent } from './components/CalculationOutput/standard-output/standard-output.component';
import { MatrixSortingComponent } from './components/matrix-sorting/matrix-sorting.component';
import { CreateDataSheetReportComponent } from './components/create-data-sheet-report/create-data-sheet-report.component';
import { ReportsDropdownComponent } from './components/reports-dropdown/reports-dropdown.component';
import { ReportViewerComponent } from './components/report-viewer/report-viewer.component';
import { JointCompletionReportComponent } from './components/joint-completion-report/joint-completion-report.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { StressfactorComponent } from './components/stressfactor/stressfactor.component';
import { TorquepatternComponent } from './components/torquepattern/torquepattern.component';
import { InformateCheckGuard } from 'src/app/guards/infomate-check.gaurd';
import { MinMaxPipeSizeComponent } from './components/controls/min-max-pipe-size/min-max-pipe-size.component';
import { TranslocoModule } from '@jsverse/transloco';
import { CalculationSettingsComponent } from './components/CalculationOutput/calculation-settings/calculation-settings.component';
import { CalculationPercentageSettingsComponent } from './components/CalculationOutput/calculation-percentage-settings/calculation-percentage-settings';
import { RouterModule } from '@angular/router';
import { UnitsComponent } from './components/units/units.component';
import { IceDatabaseContentComponent } from './components/ice-database-content/ice-database-content.component';
import { IceDatabaseSidebarComponent } from './components/ice-database-sidebar/ice-database-sidebar.component';
import { IceDatabaseComponent } from './components/ice-database/ice-database.component';
import { IceGridComponent } from './components/ice-grid/ice-grid.component';
import { FilterOptionsComponent } from './components/filter-options/filter-options.component';
import { IceDetailsComponent } from './components/ice-details/ice-details.component';
import { AdminGuradGuard } from 'src/app/guards/admin-gurad.guard';
import { DxReportViewerModule } from 'devexpress-reporting-angular';
import { SelectToolComponent } from './components/CalculationOutput/select-tool/select-tool.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
    declarations: [
        InformateComponent,
        InformateHeaderComponent,
        ClampComponent,
        StandardFlangeComponent,
        CustomFlangeComponent,
        EngineeredJointComponent,
        FlangeInputComponent,
        ProcessInformationInputComponent,
        TighteningProcedureInputComponent,
        ToolsInputComponent,
        AdvancedOutputComponent,
        BoltAndPumpOutputComponent,
        StressFactorsOutputComponent,
        InformateSubHeaderComponent,
        CustomFlangeInputComponent,
        EngineeredJointInputComponent,
        InformateSubHeaderComponent,
        ClampInputComponent,
        FlangeMaterialComponent,
        BoltMaterialComponent,
        ClampMaterialComponent,
        PipeScheduleComponent,
        HubMaterialComponent,
        SealRingMaterialComponent,
        SealRingComponent,
        ClampManufacturerComponent,
        MisalignmentFactorComponent,
        ClampSizeComponent,
        PipeSizeComponent,
        BoltTypeComponent,
        MComponent,
        YComponent,
        MaxGasketStressComponent,
        MinGasketStressComponent,
        RecGasketStressComponent,
        BoltQuantityComponent,
        PAdditionalComponent,
        ReducedAreaBoltingComponent,
        StandardComponent,
        PressureClassComponent,
        FlangeTypeComponent,
        FlangeFacingTypeComponent,
        GasketComponent,
        TighteningSpecificationComponent,
        AdditionalComponentComponent,
        NutStandardComponent,
        FlangeType2Component,
        WashersComponent,
        ThreadTypeBoltSizeComponent,
        AdvanceOptionsComponent,
        OverrideFlangeComponent,
        BoltTypeComponent,
        JointConfigurationComponent,
        JointThicknessComponent,
        BoltHoleDiameterComponent,
        GasketCompThicknessComponent,
        NearestObstructionComponent,
        ToolComponent,
        DiagramsComponent,
        DiagramImageComponent,
        DiagramFlangeOverridesComponent,
        DiagramFlangeFacingOverridesComponent,
        DiagramGasketOverridesComponent,
        LubricantComponent,
        TighteningMethodComponent,
        BreakoutComponent,
        PercentageCoverComponent,
        MatrixNameComponent,
        MatrixQuantityComponent,
        MatrixJointIdComponent,
        MatrixComponent,
        MatrixAddOrCreateComponent,
        MatrixListComponent,
        MatrixCreateComponent,
        MatrixModifyComponent,
        MatrixRemoveComponent,
        MatrixRowModifyComponent,
        MatrixRowRemoveComponent,
        MatrixRowDuplicateComponent,
        MatrixExportComponent,
        MatrixImportComponent,
        MatrixJointIdComponent,
        DiagramDimensionsComponent,
        MatrixRowViewComponent,
        WarningOutputComponent,
        CalculationOutputComponent,
        BoltOutputComponent,
        PumpOutputComponent,
        StandardOutputComponent,
        MatrixSortingComponent,
        CreateDataSheetReportComponent,
        ReportsDropdownComponent,
        ReportViewerComponent,
        JointCompletionReportComponent,
        StressfactorComponent,
        TorquepatternComponent,
        CalculationSettingsComponent,
        CalculationPercentageSettingsComponent,
        PassLabelPipe,
        MinMaxPipeSizeComponent,
        UnitsComponent,
        IceDatabaseComponent,
        IceDatabaseSidebarComponent,
        IceDatabaseContentComponent,
        IceGridComponent,
        FilterOptionsComponent,
        IceDetailsComponent,
        SelectToolComponent,
    ],
    imports: [
        CommonModule,
        SelectButtonModule,
        FormsModule,
        MaterialModule,
        NgxSliderModule,
        ReactiveFormsModule,
        HomeModule,
        TranslocoModule,
        RouterModule.forChild([
            { path: 'standardflange/:isRedirect', component: StandardFlangeComponent, canActivate: [AuthGuard, InformateCheckGuard] },
            { path: 'clamp/:isRedirect', component: ClampComponent, canActivate: [AuthGuard, InformateCheckGuard] },
            { path: 'customflange/:isRedirect', component: CustomFlangeComponent, canActivate: [AuthGuard, InformateCheckGuard] },
            { path: 'engineeredjoint/:isRedirect', component: EngineeredJointComponent, canActivate: [AuthGuard, InformateCheckGuard] },
            { path: 'matrix', component: MatrixComponent, canActivate: [AuthGuard] },
            { path: 'icedatabase', component: IceDatabaseComponent, canActivate: [AdminGuradGuard] },
            { path: '', component: StandardFlangeComponent },
        ]),
        DxReportViewerModule,
        NgbModule,
        SharedModule,
        OverlayModule,
    ],
    exports: [
        ClampComponent,
        StandardFlangeComponent,
        CustomFlangeComponent,
        EngineeredJointComponent,
        WarningOutputComponent,
        InformateComponent,
        InformateHeaderComponent,
        ClampComponent,
        StandardFlangeComponent,
        CustomFlangeComponent,
        EngineeredJointComponent,
        FlangeInputComponent,
        ProcessInformationInputComponent,
        TighteningProcedureInputComponent,
        ToolsInputComponent,
        AdvancedOutputComponent,
        BoltAndPumpOutputComponent,
        StressFactorsOutputComponent,
        InformateSubHeaderComponent,
        CustomFlangeInputComponent,
        EngineeredJointInputComponent,
        InformateSubHeaderComponent,
        ClampInputComponent,
        FlangeMaterialComponent,
        BoltMaterialComponent,
        ClampMaterialComponent,
        PipeScheduleComponent,
        HubMaterialComponent,
        SealRingMaterialComponent,
        SealRingComponent,
        ClampManufacturerComponent,
        MisalignmentFactorComponent,
        ClampSizeComponent,
        PipeSizeComponent,
        BoltTypeComponent,
        MComponent,
        YComponent,
        MaxGasketStressComponent,
        MinGasketStressComponent,
        RecGasketStressComponent,
        BoltQuantityComponent,
        PAdditionalComponent,
        ReducedAreaBoltingComponent,
        StandardComponent,
        PressureClassComponent,
        FlangeTypeComponent,
        FlangeFacingTypeComponent,
        GasketComponent,
        TighteningSpecificationComponent,
        AdditionalComponentComponent,
        NutStandardComponent,
        FlangeType2Component,
        WashersComponent,
        ThreadTypeBoltSizeComponent,
        AdvanceOptionsComponent,
        OverrideFlangeComponent,
        BoltTypeComponent,
        JointConfigurationComponent,
        JointThicknessComponent,
        BoltHoleDiameterComponent,
        GasketCompThicknessComponent,
        NearestObstructionComponent,
        ToolComponent,
        DiagramsComponent,
        DiagramImageComponent,
        DiagramFlangeOverridesComponent,
        DiagramFlangeFacingOverridesComponent,
        DiagramGasketOverridesComponent,
        LubricantComponent,
        TighteningMethodComponent,
        BreakoutComponent,
        PercentageCoverComponent,
        MatrixNameComponent,
        MatrixQuantityComponent,
        MatrixJointIdComponent,
        MatrixComponent,
        MatrixAddOrCreateComponent,
        MatrixListComponent,
        MatrixCreateComponent,
        MatrixModifyComponent,
        MatrixRemoveComponent,
        MatrixRowModifyComponent,
        MatrixRowRemoveComponent,
        MatrixRowDuplicateComponent,
        MatrixExportComponent,
        MatrixImportComponent,
        MatrixJointIdComponent,
        DiagramDimensionsComponent,
        MatrixRowViewComponent,
        WarningOutputComponent,
        CalculationOutputComponent,
        BoltOutputComponent,
        PumpOutputComponent,
        StandardOutputComponent,
        MatrixSortingComponent,
        CreateDataSheetReportComponent,
        ReportsDropdownComponent,
        ReportViewerComponent,
        JointCompletionReportComponent,
        StressfactorComponent,
        TorquepatternComponent,
        CalculationSettingsComponent,
        CalculationPercentageSettingsComponent,
        PassLabelPipe,
        MinMaxPipeSizeComponent,
        UnitsComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    // entryComponents: [ReportViewerComponent],
})
export class InformateModule {}
